<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">店舗管理画面</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div id="shop_link_list" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/import_work_schedule">シフトインポート (CSV)</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/work_schedule">出勤情報</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/master/job_type">業務設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/master/staff">スタッフマスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/todo_download">ToDo一覧ダウンロード</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/master/job_position">役割マスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/master/skill_attribute">スキル設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop/import_signage_file">サイネージ表示画像インポート</router-link>
				</div>
			</div>
			<div class="uk-margin">
				<router-link id="return_to_reservation_list" class="uk-margin-large-top uk-card uk-card-default uk-card-body uk-display-block uk-text-center" v-bind:to="moveToReservationListURL">予約一覧画面に戻る</router-link>
			</div>
		</div>
		<!--/ Main -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'

	export default {
		name: 'ShopHome',
		comments: [],
		data () {
			return {
				shop_id: null,
				current_staff: null
			}
		},
		computed: {
			moveToReservationListURL () {
				return '/reservation_list/' + this.shop_id
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			loadShopId () {
				let self = this

				StaffAuth.current().then(function (response) {
					self.shop_id = response.data.data.shop_id
					self.current_staff = response.data.data
				})
			}
		},
		created () {
			this.loadShopId()
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 管理者スタッフではない場合
					self.$router.push('/')
				}
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#shop_link_list > div a,
	#return_to_reservation_list {
		border: solid 1px #DDD;
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopHomePage.vue